import React from 'react';

const Footer = () => {
  return (
    <footer className='py-12'>
      <div className='container mx-auto text-center text-base'>
          &copy; 2021 AbbVie Inc. All rights reserved.
      </div>
    </footer>
  )
};

export default Footer;
